import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState } from 'react';
import { createContainer } from 'unstated-next';
function useMenuCounter() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    flatMenuKeys = _useState2[0],
    setFlatMenuKeys = _useState2[1];
  return {
    flatMenuKeys: flatMenuKeys,
    setFlatMenuKeys: setFlatMenuKeys
  };
}
var MenuCounter = createContainer(useMenuCounter);
export { MenuCounter };